// v2.18.4a — Helper localStorage pour l'état collapsé/expandé des cards livreur.

const KEY = "civ_courier_panels";

function _read() {
  try {
    const raw = typeof window !== "undefined" ? window.localStorage.getItem(KEY) : null;
    if (!raw) return {};
    const o = JSON.parse(raw);
    return (o && typeof o === "object") ? o : {};
  } catch (_) { return {}; }
}

function _write(obj) {
  try { window.localStorage.setItem(KEY, JSON.stringify(obj)); } catch (_) {}
}

export function getPanelState(id, fallback = "expanded") {
  const o = _read();
  return o[id] === "collapsed" || o[id] === "expanded" ? o[id] : fallback;
}

export function setPanelState(id, state) {
  const o = _read();
  o[id] = state === "collapsed" ? "collapsed" : "expanded";
  _write(o);
}

export function togglePanelState(id) {
  const next = getPanelState(id) === "collapsed" ? "expanded" : "collapsed";
  setPanelState(id, next);
  return next;
}
